"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseString = parseString;
exports.parseArray = parseArray;
exports.parseBoolean = parseBoolean;
exports.parseUnknownObject = parseUnknownObject;
exports.parseUndefinedOr = parseUndefinedOr;
function parseString(string) {
    if (typeof string === "string") {
        return string;
    }
    throw new Error("Couldn't parse String");
}
function parseArray(array) {
    if (Array.isArray(array)) {
        return array;
    }
    throw new Error("Couldn't parse List or Undefined");
}
function parseBoolean(boolean) {
    if (typeof boolean === "boolean") {
        return boolean;
    }
    throw new Error("Couldn't parse Boolean or undefined");
}
function parseUnknownObject(object) {
    if (typeof object === "object") {
        return object;
    }
    throw new Error("Couldn't parse object");
}
function parseUndefinedOr(parse, thing) {
    if (typeof thing === "undefined") {
        return thing;
    }
    else {
        return parse(thing);
    }
}
